import React from "react";
import CreateMissionEarningType from "../../../screens/create-mission/CreateMissionEarningType";
import { FIND_CCT } from "../../../graphql/cct";
import { currentLang } from "../../../atoms/i18n";
import { newMissionState } from "../../../atoms/core";
import { MockedProvider } from "@apollo/client/testing/react";
import VStack from "../../../ui_atoms/VStack";
import type { Meta, StoryObj } from "@storybook/react";
import MissionScreensManager from "../../../contexts/CreateMissionManager";
import { AtomsHydrator } from "../../../atoms/atoms-hydrator";

const mocks = [
    {
        request: {
            query: FIND_CCT,
            variables: { stateCode: "VS", limit: 100 },
        },
        result: () => ({
            data: {
                findCct: {
                    elements: [
                        {
                            __typename: "CCT",
                            id: "cct-1",
                            cctEditionId: "cct-1-A",
                            cctVersionId: "v-cct-1-A",
                            cctContractId: "cct-contract-1",
                            name: "My CCT 1",
                            hoursPerWeek: 42.5,
                            active: true,
                            intercomMainArticleId: "intercom-main-article-id",
                            intercomHelpArticleId: "intercom-help-article-id",
                        },
                        {
                            __typename: "CCT",
                            id: "cct-2",
                            cctEditionId: "cct-2-A",
                            cctVersionId: "v-cct-2-A",
                            cctContractId: "cct-contract-2",
                            name: "My CCT 2",
                            hoursPerWeek: 30.0,
                            active: false,
                            intercomMainArticleId: "intercom-main-article-id",
                            intercomHelpArticleId: "intercom-help-article-id",
                        },
                        {
                            __typename: "CCT",
                            id: "815001",
                            cctEditionId: "cct-3-A",
                            cctVersionId: "v-cct-3-A",
                            cctContractId: "815001", // see env.CCT_DEFAULT_CONTRACT_ID
                            name: "LA seule qui marche",
                            hoursPerWeek: 44.0,
                            active: true,
                            intercomMainArticleId: "intercom-main-article-id",
                            intercomHelpArticleId: "intercom-help-article-id",
                        },
                    ],
                    pageInfo: {
                        totalElements: 2,
                    },
                },
            },
        }),
    },
];

const StoryComponent = () => {
    return (
        <AtomsHydrator
            atomValues={[
                [currentLang, "fr"],
                [
                    newMissionState,
                    {
                        id: "fake-id",
                        currentContract: {
                            contractEffectiveAsset: { id: "007" },
                            hoursPerWeekFullTime: 42,
                            workingAddress: {
                                locality: {
                                    state: {
                                        code: "VS",
                                    },
                                },
                            },
                        },
                    },
                ],
            ]}
        >
            <MockedProvider mocks={mocks}>
                <VStack gap={1} style={{ alignItems: "stretch", alignSelf: "stretch", flex: 1 }}>
                    <MissionScreensManager
                        onValidate={() => {
                            alert("Screen Validated");
                        }}
                    >
                        <CreateMissionEarningType />
                    </MissionScreensManager>
                </VStack>
            </MockedProvider>
        </AtomsHydrator>
    );
};

const meta = {
    title: "CreateMission/EarningType",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
